export const API_URL = 'https://mern-todo-app-back.herokuapp.com/API/tasks';

export default API_URL;